import React from 'react'
import {
  List,
  Datagrid,
  Edit,
  SimpleForm,
  TextField,
  EditButton,
  TextInput,
  Show,
  Filter,
  SimpleShowLayout,
  Create,
  required,
} from 'react-admin'
import HiddenUserInput from './HiddenUserInput'

const ExpenseTypeFilter = props => (
  <Filter {...props}>
    <TextInput source="name_contains" label="Name" alwaysOn />
    <TextInput source="id_contains" label="ID" />
  </Filter>
)

export const ExpenseTypeList = props => {
  return (
    <List title="Sale Type" {...props} filters={<ExpenseTypeFilter />}>
      <Datagrid rowClick="show">
        <TextField source="name" />
        <EditButton />
      </Datagrid>
    </List>
  )
}

const ExpenseTypeTitle = ({ record }) => {
  return <span>Sale Type {record ? `"${record.name}"` : ''}</span>
}

export const ExpenseTypeEdit = props => (
  <Edit title={<ExpenseTypeTitle />} {...props}>
    <SimpleForm redirect="list">
      <TextInput source="name" validate={required()} />
      <HiddenUserInput {...props} />
    </SimpleForm>
  </Edit>
)

export const ExpenseTypeShow = props => (
  <Show title={<ExpenseTypeTitle />} {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
    </SimpleShowLayout>
  </Show>
)

export const ExpenseTypeCreate = props => {
  return (
    <Create title="Create Sale Type" {...props}>
      <SimpleForm redirect="list">
        <TextInput source="name" validate={required()} />
        <HiddenUserInput {...props} />
      </SimpleForm>
    </Create>
  )
}
